import { type JSX } from 'react';
import IconButton from '@common/components/controls/IconButton';
import IconMessage from '@common/components/Messages/IconMessage';
import PopUp from '@common/components/PopUp';
import IconClose from '@common/components/svgs/common/Close';
import IconFlag from '@common/components/svgs/common/Flag';
import Translated from '@common/components/Translated';

interface GuidedTourPopupComponentProps {
  buttons?: JSX.Element;
  children: JSX.Element;
  onClose?: () => void;
}

function GuidedTourPopupComponent({
  children,
  buttons = <span />,
  onClose = () => {},
}: Readonly<GuidedTourPopupComponentProps>) {
  return (
    <PopUp
      title={(
        <span className="justify-content-space-between">
          <IconMessage
            title={<Translated id="tour.title" tagName="strong" />}
            component={IconFlag}
          />
          <IconButton icon={IconClose} onClick={onClose} color="regular" />
        </span>
      )}
      titleTag="h4"
      actionButton={buttons}
      close={onClose}
      type="small"
      noCancelButton
    >
      {children}
    </PopUp>
  );
}

export default GuidedTourPopupComponent;
